export const getErrorMessage = (errorType, errorMsg = null) => {
  if (errorMsg) {
    return errorMsg;
  }

  if (!errorType) {
    return 'שגיאה לא מזוהה';
  }

  switch (errorType) {
    case 'required':
      return 'השדה הזה הינו שדה חובה';
    case 'minLength':
      return 'השדה הזה קצר מידי';
    case 'maxLength':
      return 'השדה הזה ארוך מידי';
    case 'invalid':
      return 'השדה הזה אינו תקין';
  }
};
